import deviceType from './deviceType'
import cloneObject from './cloneObject'
import security from './security'
import sleep from './sleep'
import toast from './toast'

const plugins = {
    deviceType: deviceType,
    cloneObject: cloneObject,
    security: security,
    sleep: sleep,
    toast: toast
}

export default plugins;
